export default [
  {
    path: '/serviceAgreement',
    name: 'serviceAgreement',
    meta: {
      title: '服务协议'
    },
    component: () => import(/* webpackChunkName:'driverTest' */ './serviceAgreement.vue')
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    meta: {
      title: '隐私协议'
    },
    component: () => import(/* webpackChunkName:'driverTest' */ './privacyAgreement.vue')
  },
  {
    path: '/thridPartyAgreement',
    name: 'thridPartyAgreement',
    meta: {
      title: '第三方信息共享清单'
    },
    component: () => import(/* webpackChunkName:'driverTest' */ './thridPartyAgreement.vue')
  }
];